























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
class RouteInfoV2CityTableHeader extends Vue {}
export default RouteInfoV2CityTableHeader;
